<template>
    <div id="MyHeader">
        <header>
            <div class="header-top">
                <router-link to="/" class="logo-box">
                    <img src="../assets/images/logo.png" class="img-auto" alt="">
                </router-link>

                <div class="search-box">
                    <div class="search-input-box">
                        <span class="iconfont icon-sousuobeifen2"></span>
                        <input type="text" :placeholder="searchTips" v-model="searchKeyWord" @keyup.enter="searchFun" class="search-input">
                    </div>

                    <button class="search-btn" @click="searchFun">{{ $t('public.searchBtn') }}</button>
                </div>
                <div class="service-box">
                    <div class="service-icon">
                        <img src="../assets/images/phone-icon.png" class="img-auto" alt="">
                    </div>
                    <a href="https://wa.me/8614776148891" target="_blank" class="service-text">
                        <div class="text">
                            {{ $t('public.serviceTips') }}
                        </div>
                        <div class="phone">
                            {{ data_tel.post_content }}
                        </div>
                    </a>

                </div>
                <router-link to="/UserPage" class="to-user-index">

                    <span class="iconfont icon-gerenzhongxin"></span>

                </router-link>

                <div class="language-selector">
                    <select v-model="$i18n.locale" @change="changeLanguage">
                        <option value="zh-CN">简体中文</option>
                        <option value="en-US">English</option>
                        <!-- <option value="zh-TW">繁体中文</option> -->
                    </select>
                </div>
            </div>
            <div class="header-navigation">
                <div class="nav">
                    <ul class="nav-list">
                        <li class="level1-nav">
                            <router-link to="/" class="nav-title">
                                {{ $t('public.indexPageStr') }}
                            </router-link>
                        </li>
                        <li :class="['level1-nav', item.childrenData.length > 0 ? 'dropdown' : '']"
                            v-for="(item, index) in lineType" :key="index">

                            <router-link :to="'/LineType?line_type_id=' + item.id + '&type_name=' + ($isZh ? item.type_name : item.type_name_en)"
                                :class="['nav-title', { active: $route.path === item.url }]">{{
                                    $isZh ? item.type_name : item.type_name_en }}</router-link>
                            <div class="nav-children" v-if="item.childrenData.length > 0">
                                <ul class="nav-list-level2">
                                    <li class="level2-nav" v-for="(child, i) in item.childrenData" :key="i">
                                        <div class="nav-child-title">
                                            <router-link :to="'/LineList?line_type_id=' + child.id + '&type_name=' +child.type_name+'&type_name_en=' +child.type_name_en">{{$isZh ? child.type_name : child.type_name_en
                                            }}</router-link>

                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    </div>
</template>

<script>

export default {
    name: 'MyHeader',
    props: ['lineType', 'data_tel'],
    data() {
        return {
            searchKeyWord:'',
            searchTips: this.$t('public.searchTips'),
        }
    },
    created(){
    },
    mounted() {



    },
    methods: {
        changeLanguage() {
            // 保存语言选择到本地存储
            console.log('切换成功');
            this.searchTips = this.$t('public.searchTips')
            localStorage.setItem('language', this.$i18n.locale)
            location.reload();
        },

        searchFun(){
            if(this.searchKeyWord){
                this.$router.push({
                    path:'/SearchPage',
                    query:{
                        keyword:this.searchKeyWord,
                        nowTime:new Date().getTime()
                    }
                })
            }else{
                this.$message.error('请输入搜索内容')
            }
        }
    }
}
</script>


<style lang="scss" scoped>
#MyHeader {
    background-color: #fff;
    box-shadow: 0 4px 4px rgb(0 0 0 / 15%);
}

header {
    min-width: 1200px;
    max-width: 1500px;
    height: 160px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
}

.header-top {
    width: 100%;
    padding: 20px 0 25px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-box {
        width: 322px;
        height: 70px;


    }

    .search-box {
        width: 440px;
        display: flex;

        .search-input-box {
            width: 75%;
            height: 36px;
            border: 1px solid #0aa3f6;
            border-radius: 35px 0 0 35px;
            overflow: hidden;
            display: flex;
            align-items: center;
            font-size: 14px;

            .iconfont {
                font-size: 37px;
                color: rgba(0, 0, 0, 0.7);
            }

            input.search-input {
                padding: 0 10px 0 4px;
                height: 100%;
                width: 100%;
                outline: none;
                box-sizing: border-box;
                border: none;
            }


        }

        button.search-btn {
            height: 100%;
            width: 25%;
            // background-color: #0aa3f6;
            background-image: linear-gradient(90deg, #00a7fa 0, #0076f5 100%);
            border: none;
            color: #fff;
            cursor: pointer;
            height: 36px;
            border-radius: 0 35px 35px 0;

        }
    }

    .service-box {
        display: flex;
        align-items: center;
        width: 336px;

        .service-icon {
            flex: 0 0 40px;
            height: 40px;
            margin-right: 5px;
        }

        .service-text {
            .text {
                color: #666;
                font-size: 17px;
            }

            .phone {
                color: #ecb01f;
                font-weight: bold;
                font-size: 18px;
            }
        }
    }



}

.header-navigation {
    width: 100%;

    .nav {

        .nav-list {
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // position: relative;

            .level1-nav {
                padding: 10px 12px;
                position: relative;

                .nav-children {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    display: none;
                    z-index: 999;
                    width: 250px;

                    .nav-list-level2 {
                        padding: 10px 10px;
                        background-color: #fff;
                        display: flex;
                        border-radius: 0 0 5px 5px;
                        flex-wrap: wrap;
                        width: 100%;

                        .level2-nav {
                            font-size: 14px;

                            .nav-child-title {
                                padding: 10px 16px;
                                // min-width: 100px;

                                &:hover a {
                                    color: #0aa3f6;
                                }
                            }
                        }
                    }
                }

                .active {
                    color: #0aa3f6;
                }

                &:hover .nav-title {
                    color: #0aa3f6;
                }

                &:hover .nav-children {
                    display: flex;
                }


            }

            .level1-nav.dropdown:hover {
                &::after {
                    border-top-color: #0aa3f6;
                }
            }

            .level1-nav.dropdown::after {
                content: "";
                display: inline-block;
                width: 0;
                height: 0;
                margin-left: 2px;
                vertical-align: middle;
                border-top: 4px dashed #666;
                border-right: 4px solid transparent;
                border-left: 4px solid transparent;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

            }



        }
    }

}

.to-user-index {
    font-size: 24px;
}

.language-selector {
    position: relative;
    display: inline-block;
    min-width: 120px;
    font-family: 'Arial', sans-serif;
}

.language-selector select {
    appearance: none;
    /* 移除默认样式 */
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    padding: 8px 32px 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.language-selector select:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

/* 下拉箭头图标 */
.language-selector::after {
    content: "▼";
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 10px;
    color: #666;
    pointer-events: none;
}

/* 选项样式 */
.language-selector option {
    padding: 8px;
    background: #fff;
    color: #333;
}

/* 悬停效果 */
.language-selector option:hover {
    background-color: #f5f5f5;
}

/* 暗色模式适配 */
@media (prefers-color-scheme: dark) {
    .language-selector select {
        background-color: #333;
        color: #fff;
        border-color: #555;
    }

    .language-selector option {
        background-color: #333;
        color: #fff;
    }

    .language-selector option:hover {
        background-color: #444;
    }
}
</style>